module.exports = __webpack_public_path__ + "static/img/21.376e0bb4.png";